import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {EyeTrackerService} from 'projects/eye-tracker/src/lib/eye-tracker.service';
import {ActivatedRoute} from '@angular/router';
import {DataService} from 'projects/firebase/src/lib/services/data.service';
import {ErrorAlertComponent} from 'projects/eye-tracker/src/lib/error-alert/error-alert.component';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ITechCheckConfig} from 'projects/eye-tracker/src/lib/technical-check/technical-check.component';
import {
  ICalibConfig,
  IErrorConfig
} from 'projects/eye-tracker/src/lib/calibration/calibration.component';
import {IVisualConfig} from './visual-test/visual-test.component';
import {IStopTestConfig} from 'projects/eye-tracker/src/lib/stop-test-confirmation-modal/stop-test-confirmation-modal.component';

@Component({
  selector: 'lib-eye-tracker',
  templateUrl: './eye-tracker.component.html',
  styleUrls: ['./eye-tracking-test.component.scss'],
})
export class EyeTrackerComponent implements OnInit, OnDestroy {
  isReady = false;
  isChecked = false;
  isCalibrated = false;
  gazefilter: any;

  testId = null;
  uid: any = null;
  sid: any = null;

  detected = true;
  loading = true;

  isWasmConfigLoaded = false;

  @Output() checked = new EventEmitter<boolean>();
  @Output() testEnd = new EventEmitter<boolean>();
  @Output() calibrated = new EventEmitter<boolean>();
  @Output() calibrationStarted = new EventEmitter<boolean>();

  @Input() isEng = false;
  @Input() config: {
    techCheckConfig: ITechCheckConfig,
    calibConfig: ICalibConfig,
    errorConfig: IErrorConfig
    calibrationErrorConfig: IErrorConfig
    visualTest: IVisualConfig,
    stopTestConfig: IStopTestConfig,
  };
  @Input() environment;

  tryToInit = 3;
  WASM_URL = '';

  constructor(
    public service: EyeTrackerService,
    private route: ActivatedRoute,
    private dataService: DataService,
    private modalService: NgbModal,
  ) {
    const {sid} = this.route.snapshot.params;
    this.sid = sid;
  }

  ngOnInit(): void {
    this.initPage();
  }

  initPage() {
    this.isReady = true;
    this.isLoading = true;
    this.gazefilter = this.service.gazefilter;

    this.dataService.getSession(this.sid)
    .subscribe(res => {
      const {scenario, uid} = res;
      this.testId = scenario || 'anxiety';
      this.uid = uid;
      this.initGazefilter();

    }, (err) => {
      console.log(err);
    });
  }

  ngOnDestroy() {
    if (!!this.gazefilter) {
      this.gazefilter.tracker.dispose();
    }
  }

  initGazefilter() {
    this.tryToInit--;
    this.service.fetchConfig()
    .then((config) => {
      if (!!this.gazefilter) {
        return new Promise(resolve => resolve(this.gazefilter));
      }
      return this.service.initGaz(config);
    })
    .then((gazefilter: any) => {
      this.gazefilter = gazefilter;
      this.service.addFilter(this.gazefilter);
      return this.gazefilter;
    })
    .then((gazefilter: any) => {
      return this.service.connect(gazefilter);
    })
    .then(() => {
      this.isLoading = false;
      this.isWasmConfigLoaded = true;
      this.service.gazefilterInited = true;
      this.addFaceDetectionFilter();
    })
    .catch((err) => {
      console.log(err.message);
      if (this.tryToInit) {
        this.initGazefilter();
      } else {
        this.isLoading = false;
        this.service.gazefilterInited = false;
      }
    });
  }

  onError(type: string) {
    this.isChecked = false;
    this.isCalibrated = false;
    this.isReady = false;
    this.service.fullScreen(false)
        .then(() => {
          this.openErrorModal(type);
        });
  }

  openErrorModal(type: string) {
    const modalRef = this.modalService.open(ErrorAlertComponent, {
      centered: true,
      backdrop: true,
      keyboard: true
    });
    modalRef.componentInstance.isEng = this.isEng;
    modalRef.componentInstance.config = type === 'calibration' ? this.config.calibConfig.errorConfig : this.config.errorConfig;
    modalRef.result.then(
      () => {

      },
      () => {
        this.service.fullScreen(false)
        .then(() => {
          this.initPage();
        });
      }
    );
  }

  getTestData() {

  }

  addFaceDetectionFilter() {
    setInterval(() => {
      this.gazefilter.tracker.addListener('filter', (event: any) => {
        if (event.detected) {
          setTimeout(() => {
            this.isDetected = event.detected;
          }, 1000);
        } else {
          this.isDetected = event.detected;
        }
      });
    }, 1000);
  }

  set isDetected(prop: any) {
    this.detected = prop;
  }

  get isDetected() {
    return this.detected;
  }

  set isLoading(prop) {
    this.loading = prop;
  }

  get isLoading() {
    return this.loading;
  }

  onChecked(prop: any) {
    this.checked.emit(true);
    this.gazefilter = prop.gazefilter;
    this.isChecked = prop.checked;
  }

  onCalibrated(prop: boolean) {
    if (prop) {
      this.calibrated.emit(true);
    }
    this.isCalibrated = prop;
  }

  onCalibrationStarted(prop: boolean) {
    if (prop) {
      this.calibrationStarted.emit(true);
    }
  }

  onTestEnd(prop: boolean) {
    this.testEnd.emit(prop);
  }
}
